import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { ReactComponent as CrossIcon } from "shared/assets/Icons/cross.svg";

const mainPaths = ["/", "/home", "/wellbeing", "/resources", "/mobile-support", "/support", "/account", "/wisdom-ai"];

const noContainerPages = ["/notifications", "/positive-you-journal/create", "/positive-you-journal/edit", "/components/positive-you"];
const noBottomBarPages = ["/notifications"];

const pathIconOverrides = [
  {
    path: "/positive-you-journal/create",
    icon: <CrossIcon className="text-brand-purple w-3" title={t("positiveYou.create.closeIcon")} />,
  },
  {
    path: "/positive-you-journal/edit",
    icon: <CrossIcon className="text-brand-purple w-3" title={t("positiveYou.edit.closeIcon")} />,
  },
];

export const useAppLocation = () => {
  const location = useLocation();

  const backIcon = pathIconOverrides.find((module) => module.path === location.pathname)?.icon;

  return {
    isNotMainRoute: !mainPaths.includes(location?.pathname),
    isHomePage: location.pathname === "/home",
    shouldRenderWithContainer: !noContainerPages.includes(location?.pathname),
    shouldRenderWithBottomBar: !noBottomBarPages.includes(location?.pathname),
    backIcon,
  };
};
